export class ReviewItemFileUploaded {
  constructor(
    public readonly reviewId: number,
    public readonly reviewItemId: number,
  ) {}
}
